"use client";
// Cada página nueva abre arriba. En la vista previa embebida el marco conserva el scroll del contenedor,
// así que además de scrollTo se pide al navegador que lleve el inicio del documento a la vista.
import { useEffect } from "react";
import { usePathname } from "next/navigation";

export function AlTope() {
  const ruta = usePathname();
  useEffect(() => {
    if (location.hash) return;
    try { history.scrollRestoration = "manual"; } catch {}

    // Next conserva el layout al navegar entre secciones. En móvil, el navegador
    // puede restaurar la posición anterior después del primer scroll; se repite
    // al siguiente frame y cuando la pantalla ya terminó de cambiar.
    const subir = () => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      document.documentElement.scrollTo({ top: 0, left: 0, behavior: "auto" });
      document.body.scrollTo({ top: 0, left: 0, behavior: "auto" });
      try { if (window.self !== window.top) document.documentElement.scrollIntoView({ block: "start" }); } catch {}
    };
    subir();
    const cuadro = requestAnimationFrame(subir);
    const retraso = window.setTimeout(subir, 80);
    return () => {
      cancelAnimationFrame(cuadro);
      window.clearTimeout(retraso);
    };
  }, [ruta]);
  return null;
}
